import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../../context/TranslateContext";
import {getPermessiGruppoApi} from "../services/GruppiUtentiServices";
import {getListaKpiApi} from "../../kpi/services/KpiServices";
import ModalPermessiView from "./ModalPermessiView";

export default function ModalPermessiController({
                                              show,
                                              handleClose,
                                              idGruppo
                                          }) {

    const [permessiKpi, setPermessiKpi] = useState([]);
    const [showMsg, setShowMsg] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {translate, lingua, loadingNewLang} = useContext(TranslateContext)

    async function getKpi() {
        const permessiDb = await getPermessiGruppoApi(idGruppo);

        const response = await getListaKpiApi("?addTipi=1");
        let kpi = response.data.data;
        if (kpi) {
            let permessiKpiNew = [];
            kpi.forEach((k) => {
                let permCorrente = {
                    id_kpi: k.id_kpi,
                    tipo_imp_dati: k.tipo_imp_dati,
                    id_tipo_imp_dati: k.id_tipo_imp_dati,
                    kpi_macrocategoria: k.kpi_macrocategoria,
                    codice: k.codice,
                    descrizione: k.descrizione,
                    lettura: 0,
                    scrittura: 0,
                    approvazione: 0,
                    revisione: 0,
                    configurazione: 0,
                };

                // Se la configurazione è già stata salvata su db, recupero i permessi salvati
                if (permessiDb && permessiDb.data.data) {
                    let permCorrenteDb = permessiDb.data.data.filter((p) => p.id_kpi == k.id_kpi && p.id_tipo_imp_dati == k.id_tipo_imp_dati)
                    if (permCorrenteDb && permCorrenteDb.length > 0) {
                        permCorrente.lettura = permCorrenteDb[0].lettura;
                        permCorrente.scrittura = permCorrenteDb[0].scrittura;
                        permCorrente.approvazione = permCorrenteDb[0].approvazione;
                        permCorrente.revisione = permCorrenteDb[0].revisione;
                        permCorrente.configurazione = permCorrenteDb[0].configurazione;
                    }
                }

                permessiKpiNew.push(permCorrente);
            });

            setPermessiKpi(permessiKpiNew);
        }
    }

    useEffect(() => {
        if (show === true && loadingNewLang === false) {
            getKpi();
        }
    }, [lingua, loadingNewLang, idGruppo, show]);

    return (
        <ModalPermessiView
            setShowMsg={setShowMsg}
            show={show}
            showMsg={showMsg}
            handleClose={handleClose}
            modalMsg={modalMsg}
            translate={translate}
            permessiKpi={permessiKpi}
        />
    )

}